import { render } from "./LogValves.vue?vue&type=template&id=6088f564&scoped=true"
import script from "./LogValves.vue?vue&type=script&lang=js"
export * from "./LogValves.vue?vue&type=script&lang=js"

import "./LogValves.vue?vue&type=style&index=0&id=6088f564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6088f564"]])

export default __exports__